<label class="active label"
       *ngIf="label && !leftAlignLabel">{{ label }}
    <app-tooltip *ngIf="tooltipText"
                 type="info"
                 tooltipPosition="right"
                 record="{{tooltipText}}">
    </app-tooltip>
</label>
<div class="field"
     [class.invalid]="hasError">
    <app-input class="input"
               [(ngModel)]="value"
               [placeholder]="placeholder"
               type="number">
    </app-input>
    <app-dropdown [(ngModel)]="selectedUnit"
                  [items]="timeUnits"
                  [isDisabled]="false"
                  valueField="code"
                  displayField="label"
                  emptyText="Select interval"
                  (selectItem)="onTimeUnitChange($event)">
    </app-dropdown>
</div>
<app-form-error-list class="validation"
                     *ngIf="showErrors"
                     [errorMap]="formControl.errors">
</app-form-error-list>
